import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArticleSourceRecord } from '../../../../_models/common/article-source/article.source.record';
import { MainService } from '../../../../_services/main.service';
import { Observable } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ArticleSourceCompareComponent } from './article-source-compare/article-source-compare.component';

@Component({
  selector: 'app-article-source-response',
  templateUrl: './article-source-response.component.html',
  styleUrls: ['./article-source-response.component.scss']
})
export class ArticleSourceResponseComponent implements OnInit {
  @Input() response: ArticleSourceRecord[];
  @Output() searchAction: EventEmitter<string> = new EventEmitter();

  constructor(
    public mainService: MainService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
  }



  articleSourceCompare(item: ArticleSourceRecord): Observable<boolean> {
      const initialState = {
        item: item,
        mainService: this.mainService
      };
      const modalRef = this.modalService.show(ArticleSourceCompareComponent, { initialState, class: 'modal-max' });
      return modalRef.content.onClose;
    }

}
